import { Chip } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { Associations, ProfileItemResponse } from 'src/modules/invoice/models/invoiceTemplate';

type ListDisplayProps = {
  items: Associations[] | ProfileItemResponse[];
};

export const ListDisplay = (props: ListDisplayProps) => {
  const { items } = props;

  const getItemKey = (item: Associations | ProfileItemResponse) => {
    return (item as Associations).id ?? (item as ProfileItemResponse).memberProfileItem_id;
  };

  return (
    <Stack direction='row' spacing={1} sx={{ flexWrap: 'wrap', px: 3 }}>
      {items.length > 0 &&
        items.map((item) => {
          return (
            <Box key={getItemKey(item)} mb={1}>
              <Chip label={item.name} sx={{ mt: 0.5, fontStyle: 'normal' }} />
            </Box>
          );
        })}
    </Stack>
  );
};
